import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { gqlClient, graphql, type UseQueryReturnType } from '@tyro/api';
import { documentationKeys } from './keys';

const documentationSearch = graphql(/* GraphQL */ `
  query documentation_user_search($filter: Documentation_SearchFilter!) {
    documentation_user_search(filter: $filter) {
      pageId
      title
      spaceSlug
      spaceName
      pageSlug
      entityType
      snippet
      rank
      ancestorTitles
    }
  }
`);

export function useDocumentationSearch(query: string) {
  const trimmedQuery = query.trim();

  return useQuery({
    queryKey: documentationKeys.search(trimmedQuery),
    queryFn: async () =>
      gqlClient.request(documentationSearch, {
        filter: { query: trimmedQuery },
      }),
    enabled: trimmedQuery.length >= 2,
    placeholderData: keepPreviousData,
    staleTime: 60_000,
    select: ({ documentation_user_search }) => documentation_user_search,
  });
}

export type ReturnTypeFromUseDocumentationSearch = UseQueryReturnType<
  typeof useDocumentationSearch
>[number];
